module.exports = __webpack_public_path__ + "media/assets/icons/quill/italic-828e1d3bef9773c4bd2c0770deb9b0ee.svg";